import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";
import * as events from "../../js/state-machine/events";

export const componentName = "FileInput";

export const defaultProps = Object.freeze({
    maxFileCount: 6,
    maxFileSize: 10000000,
    acceptedFileTypes: [],
    successMessage: "<strong>Success</strong>&nbsp;File ready to submit",
    errorMaxFileCount: "<strong>Error:</strong>&nbsp;Exceeded maximum number of selectable files",
    errorMaxFileSize: "<strong>Error:</strong>&nbsp;Exceeded maximum file size",
    errorAcceptedFileTypes: "<strong>Error:</strong>&nbsp;File type not supported",
    srFileRemovedDescription: "{fileName} has been removed",
});

export const schema = Object.freeze({
    maxFileCount: matchers.gte(1),
    maxFileSize: matchers.gte(0),
    srFileRemovedDescription: matchers.string,
});

export const componentClasses = Object.freeze({
    base: `${prefix}file-input`,
    size: {
        lg: "",
        sm: `${prefix}file-input--sm`,
    },
    button: `${prefix}file-input__button`,
    control: `${prefix}file-input__control`,
    wrapper: `${prefix}file-input__wrapper`,
    label: `${prefix}file-input__label`,
    helperText: `${prefix}file-input__helper-text`,
    errorText: `${prefix}error-text`,
    list: `${prefix}file-input__list`,
    srLabel: `${prefix}file-input__sr-only`,
    item: {
        base: `${prefix}file-input__item`,
        text: `${prefix}file-input__item__text`,
        content: `${prefix}file-input__item__content`,
        name: `${prefix}file-input__item__name`,
        size: `${prefix}file-input__item__size`,
        uploading: `${prefix}file-input__item--uploading`,
        success: `${prefix}file-input__item--success`,
        error: `${prefix}file-input__item--error`,
        feedback: `${prefix}file-input__item__feedback`,
        feedbackIcon: `${prefix}file-input__item__feedback__icon`,
        close: `${prefix}file-input__item__close`,
    },
});

export const eventMap = Object.freeze({
    itemAdded: events.added(componentName),
    itemDeleted: events.deleted(componentName),
});

export const views = Object.freeze({
    item: {
        rest: {
            classList: [
                `${componentClasses.item.base}`,
                `!${componentClasses.item.error}`,
                `!${componentClasses.item.uploading}`,
                `!${componentClasses.item.success}`,
            ],
        },
        error: {
            classList: [
                `${componentClasses.item.base}`,
                `${componentClasses.item.error}`,
                `!${componentClasses.item.uploading}`,
                `!${componentClasses.item.success}`,
            ],
        },
        uploading: {
            classList: [
                `${componentClasses.item.base}`,
                `!${componentClasses.item.error}`,
                `${componentClasses.item.uploading}`,
                `!${componentClasses.item.success}`,
            ],
        },
        success: {
            classList: [
                `${componentClasses.item.base}`,
                `!${componentClasses.item.error}`,
                `!${componentClasses.item.uploading}`,
                `${componentClasses.item.success}`,
            ],
        },
    },
    button: {
        rest: { attrs: { disabled: null } },
        inactive: { attrs: { disabled: "disabled" } },
    },
    invalid: { attrs: { "aria-invalid": "true" } },
    valid: { attrs: { "aria-invalid": null } },
});
